import { useEffect, useState } from "react";

export function useIsAdmin() {
  const [isAdmin, setIsAdmin] = useState(
    Boolean(typeof window !== "undefined" && localStorage.getItem("arnav_admin_token"))
  );

  useEffect(() => {
    const check = () => setIsAdmin(Boolean(localStorage.getItem("arnav_admin_token")));
    window.addEventListener("storage", check);
    // custom event so same-tab login/logout is picked up
    window.addEventListener("arnav-auth-change", check);
    return () => {
      window.removeEventListener("storage", check);
      window.removeEventListener("arnav-auth-change", check);
    };
  }, []);

  return isAdmin;
}
